import {
  type StaticApplicationsFooterBffNavigationDto,
  StaticNavigationNavigationItemDtoLinkType,
  type StaticApplicationsFooterBffNavigationItemDto,
} from '@ori/static-api-client-react';

import { MAX_COLUMNS } from '../components/SiteLinks/constants';

export interface SiteLinksColumn extends StaticApplicationsFooterBffFooterDtoItem {
  children: StaticApplicationsFooterBffFooterDtoItem[];
}
export type StaticApplicationsFooterBffFooterDtoItem = Omit<StaticApplicationsFooterBffNavigationItemDto, 'title'> & {
  title: string;
};
export const isLinkRenderable = (item: StaticApplicationsFooterBffNavigationItemDto) => Boolean(item.title);

export const getSiteLinksColumns = (
  footer: StaticApplicationsFooterBffNavigationDto | undefined,
): SiteLinksColumn[] => {
  const footerColumns = footer?.children.filter(
    (item) => item.linkType === StaticNavigationNavigationItemDtoLinkType.FooterColumn,
  );
  const columns =
    footerColumns
      ?.filter((column): column is StaticApplicationsFooterBffFooterDtoItem => isLinkRenderable(column))
      .slice(0, MAX_COLUMNS) ?? [];

  const onlyRenderableChildren = columns.map((column) => ({
    ...column,
    children: column.children.filter((child): child is StaticApplicationsFooterBffFooterDtoItem =>
      isLinkRenderable(child),
    ),
  }));

  return onlyRenderableChildren;
};
